import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import LoginForm from '../loginForm';
import TwoFactorForm from '../twoFALoginForm';
import RecoveryCodeForm from '../recoveryCodeForm';
import LinkContainer from './links';

 @inject('authStore', 'configurationsStore', 'authenticationProvidersStore') @observer
export default class UserLoginFormContainer extends Component {

    componentDidMount() {
        const { isMultitenancyMode } = this.props.configurationsStore;
        if(!isMultitenancyMode)
            this.props.authenticationProvidersStore.getAllAuthenticationProviders();
    }

     render() {
       const {values} = this.props.authStore;
        const {isMultitenancyMode} = this.props.configurationsStore;
        const {authenticationProviders} = this.props.authenticationProvidersStore;

        if(authenticationProviders === undefined) {
            return null;
        }

        let tenantHeader = isMultitenancyMode ? <div className='tenant-header'>Account: {values.tenant} </div> : null;

         const twoFactorForm = <TwoFactorForm onPrevStepClick={this.onPrevStepClick} returnUrl={this.props.returnUrl} />;
         const recoveryCodeForm = <RecoveryCodeForm onPrevStepClick={this.onPrevStepClick} returnUrl={this.props.returnUrl} />;
         let userLoginForm = <div className='user-login-form' data-cy='user-login-form'>{tenantHeader}< LoginForm returnUrl={this.props.returnUrl} /><LinkContainer onPrevStepClick={this.props.onPrevStepClick} /></div >;
         
         if (this.props.authStore.values.isRecovery)
             return recoveryCodeForm;
         else if (this.props.authStore.requireTwoFactorAuth)
             return twoFactorForm;
         else
             return userLoginForm;

    }
}